import { render, staticRenderFns } from "./SithMesPrdPpComponentList.vue?vue&type=template&id=8018efdc&"
import script from "./SithMesPrdPpComponentList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdPpComponentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports